import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import TpClientPaymentService from '../../../Services/tpClientPaymentService';
import ApplyTpPaymentItem from '../../../Domain/ApplyTpPaymentItem';
import OptionValue from '../../../Communication/OptionValue';

export default class ApplyPartialTpRelatedClientPaymentWindowDescription extends React.Component {
  static titleForEdit = 'Apply Partial Payment';
  static itemType = ApplyTpPaymentItem;
  static serviceFunction = (edited) => TpClientPaymentService.ApplyPaymentToOldInvoice(edited, null, false, null);

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'AmountApplied',
          label: 'Amount',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ApplyPartialTpRelatedClientPaymentWindowDescription.validateAmount,
        },
        {
          fieldName: 'TypeOfDistribution',
          label: 'Type of Distribution',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: ApplyPartialTpRelatedClientPaymentWindowDescription.getApplyTypesFunction(),
          validityChecker: ValidityHelper.AlwaysFlawless,
          tooltipText:
            'If you select "Apply evenly", the amount will be distributed evenly across all selected invoices. If you select "Apply the same", the same amount will be applied to each selected invoice.',
        },
        {
          fieldName: 'ApplyEvenlyPlaceholder',
          label: ' ',
          numberOfRows: 1,
          validityChecker: ValidityHelper.emptyValidityChecker,
          type: InputTypesEnum.TextBoxReadOnly,
          placeholder: '"Apply evenly", the amount will be distributed evenly across all selected invoices.',
          className: 'col-12',
          hide: (item) => item.TypeOfDistribution !== 'Apply evenly',
        },
        {
          fieldName: 'ApplySamePlaceholder',
          label: ' ',
          numberOfRows: 1,
          validityChecker: ValidityHelper.emptyValidityChecker,
          type: InputTypesEnum.TextBoxReadOnly,
          placeholder: '"Apply the same", the same amount will be applied to each selected invoice.',
          className: 'col-12',
          hide: (item) => item.TypeOfDistribution !== 'Apply the same',
        },
      ],
    },
  ];

  static getApplyTypesFunction() {
    return [
      { value: 'Apply evenly', label: 'Apply evenly' },
      { value: 'Apply the same', label: 'Apply the same' },
    ];
  }

  static validateAmount(value, item) {
    // Check if amount applied can be evenly distributed, so only two decimal places are allowed, and the amount should be divisible by the number of selected invoices
    if (item.TypeOfDistribution === 'Apply evenly' && item.TpClientInvoiceIds && item.NumberOfItemsSelected > 0) {
      const amountPerInvoice = item.AmountApplied / item.NumberOfItemsSelected;

      const decimalPlaces = (amountPerInvoice.toString().split('.')[1] || '').length;

      if (decimalPlaces > 2) {
        return `Amount cannot be evenly distributed to two decimal places. The amount per invoice is ${amountPerInvoice}. Please adjust the amount.`;
      }
    }

    const requiredValidationResult = ValidityHelper.forRequiredNumberFieldGreaterThanZero(item.AmountApplied);
    if (requiredValidationResult !== '') {
      return requiredValidationResult;
    }

    return '';
  }
}
